// This import loads the firebase namespace along with all its type information.
import Game from './game-model'

export async function load_games(): Promise<Game[]> {
  throw 'Not implemented'
}

export async function delete_game(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_game(): Promise<Game> {
  throw 'Not implemented'
}
